<template>
  <div class="main" style="padding-top:0px">
    <parallax :overlay="false" :classes="'without-img'" style="background-color: #d4d4d4;margin-top: 0px">
      <template slot="content">
        <div>
          <span class="title-content">
            <text-lang :lang="lang">
              <template slot="es">Quienes Somos</template>
              <template slot="en">About Us</template>
            </text-lang>
          </span>
        </div>
      </template>
    </parallax>

    <section class="light-content">
      <div class="container">
        <div>
          <p class="text text-primary">
            <text-lang :lang="lang">
              <template slot="es">Somos la primera empresa especializada de inversión de capital en Venezuela e invertimos en empresas en marcha para hacerlas crecer nacionalmente e internacionalmente</template>
              <template slot="en">We are the first company in Venezuela specializing in capital investments, investing in operating companies to make them grow nationally and internationally</template>
            </text-lang>
          </p>
          <p class="text text-secondary">
            <text-lang :lang="lang">
              <template slot="es">Somos una Empresa Emisora autorizada a realizar Ofertas Públicas de Títulos Valores, lo que nos permite hacer colocaciones directas de títulos valores propias para financiar capital y abaratar costo de endeudamiento a empresas.</template>
              <template slot="en">We are constituted as a securities issuing company, and are authorized to issue equity and debt securities in the stock market; raising capital to invest and finance companies, improving and enhancing their overall performance and allowing them to grow.</template>
            </text-lang>
          </p>
          <p class="text text-secondary">
            <text-lang :lang="lang">
              <template slot="es">Estamos inscritos en el Registro Nacional de Valores de la Superintendencia Nacional de Valores (Sunaval) y en la Bolsa de Valores de Caracas.</template>
              <template slot="en">We are registered in the Securities National Registry (Registro Nacional de Valores) of the National Securities commission (Sunaval), and currently trade in the Caracas Stock Exchange (BVC).</template>
            </text-lang>
          </p>	
          <p class="text text-secondary">
            <text-lang :lang="lang">
              <template slot="es">Poseemos un capital democratizado distribuido entre 106 accionistas directos y más de 2.000 en forma indirecta.</template>
              <template slot="en">As a publicly traded company, our shareholders' equity is distributed among hundreds of direct and thousands of indirect shareholders.</template>
            </text-lang>
          </p>
          <p class="text text-secondary" style="margin-bottom: 0px !important">
            <text-lang :lang="lang">
              <template slot="es">Directivos y promotores con experiencia financiera y gerencial, quienes fijarán directrices para el crecimiento de empresas.</template>
              <template slot="en">Our Board of Directors and our Management team count with a broad experience in corporate finance and management, offering the companies we invest in with the highest standards and best practices in the industry to make them grow and develop.</template>
            </text-lang>
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import Parallax from '@/components/Parallax.vue'
import TextLang from '@/components/TextLang.vue'

export default {
  name: 'About',
  props: ['lang'],
  components: {
    Parallax,
    TextLang
  }
}
</script>
